<template>
  <!-- 上传进度组件 -->
  <el-popover
    placement="bottom"
    popper-class="popperPadding"
    trigger="click"
    width="500"
    v-model="internalVisible"
  >
    <el-badge slot="reference" :hidden="uploadProgressList.length === 0"
              :value="uploadProgressList.length"
              class="base-margin__right-20">
      <i class="el-icon-upload base-cursor__pointer badge-size"></i>
    </el-badge>

    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>文件上传进度</span>
        <el-button v-if="uploadProgressList.length === 0" class="no-message base-color__black" type="text">
          暂无上传任务
        </el-button>
        <el-button v-if="uploadProgressList.length !== 0" class="no-message" type="text" @click="clearAll">
          清空列表
        </el-button>
      </div>

      <div v-for="(file, index) in uploadProgressList" :key="index" class="upload-item">
        <div class="file-info">
          <span class="file-name" :title="file.name">{{ file.name }}</span>
          <span class="file-size">{{ formatFileSize(file.size) }}</span>
        </div>

        <!-- 上传进度 -->
        <div class="progress-container">
          <el-progress :percentage="file.progress || 0" :color="customColors" :show-text="false" />
          <span class="progress-text">{{ getProgressText(file) }}</span>
        </div>

        <!-- 同步进度 -->
        <div v-if="file.syncProgress !== undefined && file.syncProgress >= 0" class="progress-container">
          <el-progress :percentage="file.syncProgress || 0" :color="customColors" :show-text="false" />
          <span class="progress-text">{{ getSyncProgressText(file) }}</span>
        </div>

        <div class="file-status">
          <span :class="['status', getStatusClass(file.progress, file.syncProgress)]">
            {{ getStatusText(file.progress, file.syncProgress) }}
          </span>
        </div>
        <el-divider style="margin: 8px 0;"></el-divider>
      </div>

      <div v-if="uploadProgressList.length === 0" class="empty-state">
        <i class="el-icon-upload"></i>
        <p>暂无上传任务</p>
      </div>
    </el-card>
  </el-popover>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { cosSliceFile } from '@/common/utils/cosApi';
import { postRequest } from '@/common/libs/request';

export default {
  name: 'UploadProgress',

  props: {
    // 组件是否可见
    visible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      // 组件内部可见状态
      internalVisible: this.visible,
      uploadProgressList: [],
      customColors: [
        { color: '#f56c6c', percentage: 20 },
        { color: '#e6a23c', percentage: 40 },
        { color: '#5cb87a', percentage: 60 },
        { color: '#1989fa', percentage: 80 },
        { color: '#6f7ad3', percentage: 100 },
      ],
    };
  },
  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },
  watch: {
    visible(newVal) {
      this.internalVisible = newVal;
    },
    'app.uploadProgressList'(fileList) {
      this.internalVisible = true;

      // 过滤掉已经上传完成的文件，只处理需要上传的新文件
      const newFiles = fileList.filter(item => {
        // 检查是否已经在uploadProgressList中存在且未上传完成
        const existingFile = this.uploadProgressList.find(existing => existing.name === item.name);
        if (existingFile) {
          // 如果文件已存在且未上传完成，更新进度信息
          if (existingFile.progress < 100) {
            this.$set(this.uploadProgressList, this.uploadProgressList.indexOf(existingFile), item);
          }
          return false; // 不添加到新文件列表
        }
        return true; // 新文件，需要处理
      });

      // 只添加真正的新文件
      if (newFiles.length > 0) {
        this.uploadProgressList.push(...newFiles);
        this.cosSliceFileList();
      }
    },
  },

  methods: {
    cosSliceFileList() {
      this.uploadProgressList.forEach((item) => {
        // 检查文件是否已经上传完成，避免重复上传
        if (item.progress === 100) {
          console.log(`文件 ${item.name} 已经上传完成，跳过重复上传`);
          return;
        }

        // 检查文件是否正在上传中，避免重复开始上传
        if (item.progress > 0 && item.progress < 100) {
          console.log(`文件 ${item.name} 正在上传中，进度 ${item.progress}%，跳过重复开始上传`);
          return;
        }

        // if (item.progress === 100) {
        //   postRequest('/api/eda/common/cluster/syncCosToDist', item.syncParams);
        //   return;
        // };
        cosSliceFile(item.raw, {}, (progress) => {
          const existingIndex = this.uploadProgressList.findIndex(existing => existing.name === item.name);
          this.$set(this.uploadProgressList, existingIndex, { ...item, progress });

          if (progress === 100) {
            postRequest('/api/eda/common/cluster/syncCosToDist', item.syncParams);
            this.pollUploadSyncProgress(item.syncParams.cosFilePath, item.syncParams.instanceFilePath, 2);
          };

          // 检查所有文件是否都上传完成
          const allUploaded = this.uploadProgressList.every(file => file.progress === 100);
          if (allUploaded) {
            // postRequest('/api/eda/common/cluster/syncCosToDist', item.syncParams);
            // this.syncCos();
            // this.uploadProgressList = [];
          }
          //   // 实时更新上传进度
          //   this.$store.commit('app/setUploadProgressList', { name: fileName, progress, size: newFile.raw.size });
        });
      });
    },


    /**
     * 轮询查询上传文件的同步进度
     */
    pollUploadSyncProgress(cosFilePath, instanceFilePath, scene, maxRetries = 100, currentRetry = 0) {
      if (currentRetry >= maxRetries) {
        this.$message.warning('文件同步查询达到最大重试次数，请手动刷新目录查看同步结果');
        return;
      }

      // 构建查询参数
      const fileName = cosFilePath.split('/').pop();
      const queryParams = {
        files: [
          {
            cosPath: cosFilePath,
            filePath: instanceFilePath,
            name: fileName,
          },
        ],
        scene,
      };

      console.log('查询文件同步进度，参数:', queryParams);
      postRequest('/api/eda/common/cluster/describeUploadFiles', queryParams)
        .then((res) => {
          console.log('文件同步进度查询结果:', res);
          if (res.list && res.list.length > 0) {
            const fileInfo = res.list[0];
            const progress = fileInfo.process || 0;

            // 更新文件的同步进度
            const existingIndex = this.uploadProgressList.findIndex(file => file.syncParams && file.syncParams.cosFilePath === cosFilePath);
            if (existingIndex !== -1) {
              this.$set(this.uploadProgressList, existingIndex, {
                ...this.uploadProgressList[existingIndex],
                syncProgress: progress,
              });
            }

            // 检查是否同步完成
            if (progress === 100) {
              // 延迟移除已完成文件，给用户看到完成状态
              // setTimeout(() => {
              //   // 同步完成后刷新目录列表
              //   this.getDirectoryList();
              // }, 1000);
              return;
            }
          }

          // 继续轮询
          setTimeout(() => {
            this.pollUploadSyncProgress(cosFilePath, instanceFilePath, scene, maxRetries, currentRetry + 1);
          }, 1000); // 1秒后再次查询
        })
        .catch((error) => {
          console.error('查询同步进度失败:', error);
          // 出错时也继续轮询，但增加重试间隔
          setTimeout(() => {
            this.pollUploadSyncProgress(cosFilePath, instanceFilePath, scene, maxRetries, currentRetry + 1);
          }, 5000);
        });
    },

    /**
     * 清空上传列表
     */
    clearAll() {
      this.uploadProgressList = [];
    },

    /**
     * 格式化文件大小
     */
    formatFileSize(size) {
      if (!size) return '0 B';

      const units = ['B', 'KB', 'MB', 'GB'];
      let unitIndex = 0;
      let formattedSize = size;

      while (formattedSize >= 1024 && unitIndex < units.length - 1) {
        formattedSize /= 1024;
        // eslint-disable-next-line no-plusplus
        unitIndex++;
      }

      return `${formattedSize.toFixed(2)} ${units[unitIndex]}`;
    },

    /**
     * 获取进度文本
     */
    getProgressText(file) {
      if (file.status === 'success') return '上传完成';
      if (file.status === 'error') return '上传失败';
      return `${file.progress || 0}%`;
    },

    /**
     * 获取同步进度文本
     */
    getSyncProgressText(file) {
      if (file.syncProgress === undefined || file.syncProgress < 0) return '';
      if (file.syncProgress === 100) return '同步完成';
      return `${file.syncProgress || 0}%`;
    },

    /**
     * 获取状态样式类
     */
    getStatusClass(uploadProgress, syncProgress) {
      if (syncProgress !== undefined && syncProgress >= 0) {
        if (syncProgress === 0) return 'status-waiting';
        if (syncProgress > 0 && syncProgress < 100) return 'status-syncing';
        if (syncProgress === 100) return 'status-success';
      }

      if (uploadProgress === 0) return 'status-waiting';
      if (uploadProgress > 0 && uploadProgress < 100) return 'status-uploading';
      if (uploadProgress === 100) return 'status-success';
      return 'status-waiting';
    },

    /**
     * 获取状态文本
     */
    getStatusText(uploadProgress, syncProgress) {
      if (syncProgress !== undefined && syncProgress >= 0) {
        if (syncProgress === 0) return '等待同步';
        if (syncProgress > 0 && syncProgress < 100) return '同步中';
        if (syncProgress === 100) return '同步完成';
      }

      if (uploadProgress === 0) return '等待上传';
      if (uploadProgress > 0 && uploadProgress < 100) return '上传中';
      if (uploadProgress === 100) return '上传完成';
      return '等待上传';
    },
  },
};
</script>

<style lang="scss" scoped>
// icon图标的大小
.badge-size {
  font-size: 20px;
}

// 取消popover组件的padding
.popperPadding {
  padding: 0;
}

// 修改card的样式
.box-card {
  width: 100%;
  border: none;
  max-height: 700px;
  overflow: auto;
}

.clearfix {

}

// card主体内容的间距以及文字大小
.upload-item {
  padding: 8px 0;
}

.file-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;

  .file-name {
    font-size: 14px;
    color: #303133;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 70%;
  }

  .file-size {
    font-size: 12px;
    color: #909399;
  }
}

.progress-container {
  display: flex;
  align-items: center;
  gap: 8px;

  .el-progress {
    flex: 1;
  }

  .progress-text {
    font-size: 12px;
    color: #606266;
    min-width: 50px;
  }
}

.file-status {
  margin-top: 4px;
  text-align: right;

  .status {
    font-size: 12px;
    padding: 2px 6px;
    border-radius: 2px;

    &.status-waiting {
      color: #909399;
      background: #f4f4f5;
    }

    &.status-uploading {
      color: #e6a23c;
      background: #fdf6ec;
    }

    &.status-syncing {
      color: #1989fa;
      background: #ecf5ff;
    }

    &.status-success {
      color: #67c23a;
      background: #f0f9eb;
    }

    &.status-error {
      color: #f56c6c;
      background: #fef0f0;
    }
  }
}

// 暂无消息 清空列表的css
.no-message {
  float: right;
  padding: 3px 0;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #909399;

  i {
    font-size: 48px;
    margin-bottom: 16px;
  }

  p {
    margin: 0;
    font-size: 14px;
  }
}
</style>
